<section class="catalog">
  <!-- Default Header -->
  <header class="catalog__header mb-4 pt-4">
    <div class="container topbar-padding-top">
      <h1 class="fw-bold mb-0">
        {{ searchQuery ? searchQuery : ('producten-overzicht-titel' | fromDictionary) }}
      </h1>
      @if (searchQuery) {
        @if (searchResults$ | async; as products) {
          <span class="d-inline-block mb-1 text-lowercase">
            {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
            {{ (products.length === 1 ? 'zoekresultaat-label' : 'zoekresultaten-label') | fromDictionary }}
          </span>
        }
      }
    </div>
  </header>

  <div class="container">
    <main class="row">
      <div class="col-12">
        @if (searchResults$ | async; as products) {
          <ul class="row">
            @for (product of products; track product.id) {
              <li class="mb-5 col-6 col-md-4">
                <app-product-card [product]="product" [sizes]="{ xs: 6, md: 2, lg: 1 }"></app-product-card>
              </li>
            }
            @if (!products.length && (loading$ | async) === false) {
              <li class="mb-5 col-12 my-2 text-center">
                <p>{{ 'product-overzicht-geen-resultaten' | fromDictionary }}</p>
              </li>
            }
            @if (!products.length && (loading$ | async)) {
              <li class="mb-5 col-12 my-2 text-center">
                <p>{{ 'product-overzicht-loading' | fromDictionary }}</p>
              </li>
            }
          </ul>
        }
      </div>
      @if ((page$ | async)?.hasNextPage) {
        <div class="text-center mt-5">
          <button class="button button-outline button--secondary" (click)="loadMore()" [disabled]="(loading$ | async) === true">
            @if ((loading$ | async) === true) {
              <span class="icon-loader css-icon" title="loading..."></span>
            }
            <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
          </button>
        </div>
      }
    </main>
  </div>
</section>

<app-json-ld [json]="scheme"></app-json-ld>
<app-json-ld [json]="breadcrumbScheme"></app-json-ld>
